import {ChaseFormStatus} from "../hooks/use-chase-form-status"

type SubmitDisabledCriteria = Record<'dirty' | 'isValid' | 'isSubmitting', boolean> & {
    chaseFormStatus: ChaseFormStatus
}

export const submitDisabled = ({dirty, isValid, isSubmitting, chaseFormStatus}: SubmitDisabledCriteria): boolean => {
    return !isValid || isSubmitting || chaseFormStatus === ChaseFormStatus.NOT_VALID
}
